import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject, injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import AnimateToAnchorHandler from '@Component/AnimateToAnchor/AnimateToAnchorHandler';
import type Scrollable from '@Service/Scrollable/Scrollable';
import type AccessorInterface from '@123/druid/dist/Framework/View/AccessorInterface';
import type ViewAccessor from '@123/druid/dist/Framework/View/ViewAccessor';

@component
@injectable()
export default class AnimateToAnchor implements AccessorInterface {
    constructor(@inject('WindowScroller') private windowScroller: Scrollable) {}

    public setAccessor(accessor: ViewAccessor): void {
        new AnimateToAnchorHandler(accessor, this.windowScroller).attach();
    }
}
